const CourseTier = ({ tier }) =>
    !!tier &&
        <span className={`tag tier-${tier.toLowerCase()}`}>
            {/*<span className="fa-solid fa-skull-crossbones" />*/}
            <span className="tag-text">{tier}</span>
        </span>

export default CourseTier;